import { useMemo } from "react";

import { useTireResults } from "../../useTireResults";
import { useTireLoadRating } from "./useTireLoadRating";

export const useTireLoadRatingOptions = (): Option[] => {
  const { data: info } = useTireResults({
    keepPreviousData: true,
  });
  const [state] = useTireLoadRating();

  const options = useMemo((): Option[] => {
    if (!info) return [];
    const acc = {} as Record<string, null>;
    for (const { partDetails } of info.allParts) {
      const { tireLoadRating } = partDetails.primaryPart;
      acc[tireLoadRating] = null;
    }
    const entries = Object.entries(acc);
    const result = entries
      .map(([tireLoadRating]) => {
        const count = info.allParts.reduce(
          (acc, { partDetails }) =>
            partDetails.primaryPart.tireLoadRating === tireLoadRating
              ? acc + 1
              : acc,
          0
        );
        const checked = state.includes(tireLoadRating);
        return { checked, count, tireLoadRating };
      })
      .sort((a, b) => a.tireLoadRating.localeCompare(b.tireLoadRating));
    return result;
  }, [info?.allParts, state]);

  return options;
};

type Option = {
  checked: boolean;
  count: number;
  tireLoadRating: string;
};
